import { get, isNumber, isArray, isString } from 'lodash';

const PropTypes = class {
  static isWithinRange = (min, max) => (props, propName, componentName) => {
    const value = get(props, propName);

    if (!isNumber(value)) {
      throw new Error(`${propName} (${value}) must be a number (${componentName}).`);
    }

    if (value > max || value < min) {
      throw new Error(
        `${propName} (${value}) must be within [${min}, ${max}] range (${componentName}).`
      );
    }
  };

  static colorSwatch = (props, propName) => {
    const array = get(props, propName);
    const imageUrl = get(props, 'imageUrl');

    if (!array) {
      return new Error(`${propName} is a required prop.`);
    }

    if (!isArray(array)) return new Error(`${propName} must be an array.`);

    if (!imageUrl && array.length < 1) return new Error(`${propName} must have at least 1 value.`);

    if (array.length > 3) return new Error(`${propName} must have at fewer than 3 values.`);

    for (let i = 0; i < array.length; i += 1) {
      if (!isString(array[i])) {
        return new Error(`${propName} must be an array of strings.`);
      }
    }

    return null;
  };
};

export default PropTypes;
